<template>
  <div
    class="m-select-control-create-new-option"
    @click="$emit('addItem')"
  >
    <MProviderIcon
      :icon="iconAdd"
      class="m-select-control-create-new-option__icon"
    />
    <div class="m-select-control-create-new-option__text">
      {{ _getTr('create_new_option') }}
    </div>
  </div>
</template>

<script>
  import iconAdd from 'assets/icons/plus-circle.svg';
  import MProviderIcon from 'components/Design/MProviderIcon';

  export default {
    name: 'MSelectControlCreateNewOption',
    components: {MProviderIcon},
    data () {
      return {
        iconAdd
      };
    }
  };
</script>

<style>
  .m-select-control-create-new-option {
    color: var(--gray-text-color);

    cursor: pointer;

    display: flex;

    padding: 8px;
  }

  .m-select-control-create-new-option:hover {
    background: var(--action-background-color);
  }

  .m-select-control-create-new-option__text {
    margin-left: 4px;
  }

  .m-select-control-create-new-option__icon {
    width: 16px;
    height: 16px;
  }
</style>
